module.exports = "<div class=\"align-right spacer\">\r\n  <button \r\n    id=\"add-scene-button\"\r\n    mat-raised-button color=\"accent\" \r\n    (click)=\"openDialog()\">Add Scene</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/add-scene/add-scene.component.html
// module id = ../../../../../src/app/generator/add-scene/add-scene.component.html
// module chunks = main